module.exports = __webpack_public_path__ + "img/418.b273504c.png";